var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _c("Snackbar", { ref: "snackbar" }),
      _c("v-main", [_c("router-view")], 1),
      _c(
        "v-footer",
        { attrs: { app: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-container",
                { attrs: { caption: "" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-1 pb-1", attrs: { justify: "center" } },
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.clubData.Vereins_Name))]),
                      _vm._v(
                        "     " +
                          _vm._s(_vm.clubData.Vereins_Strasse) +
                          " — " +
                          _vm._s(_vm.clubData.Vereins_PlzOrt) +
                          " —  "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "//" + _vm.clubData.VER_HOMEPAGE,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.clubData.VER_HOMEPAGE))]
                      ),
                      _vm._v(" — " + _vm._s(_vm.clubData.VER_TEL) + "     "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }